import { ChangeFunctionType } from '@bookjane2/bookjane-design-library/lib/common.types';
import { Flex } from 'components/Flex';
import { PayCodeOptionType, PayCodeSelectInput } from 'components/PayCodeSelectInput';
import { useTranslation } from 'hooks/useTranslation';
import { FormLabel } from 'pages/CreateShiftsPage/BulkCreateShiftView/CreateShiftCard/CreateShiftCard.styled';
import { FC } from 'react';

export const TimeOffPayCodeField: FC<{
  value: string[];
  onChange: ChangeFunctionType;
  options: PayCodeOptionType[];
}> = ({ value, onChange, options }) => {
  const { t } = useTranslation();
  if (!options.length) return null;
  return (
    <Flex width="100%" flexDirection="column">
      <FormLabel>{t('schedule:TIME_OFF_PAY_CODE')}</FormLabel>
      <PayCodeSelectInput
        name="pay_code_id"
        value={value}
        onChange={onChange}
        options={options}
        placeholder={t('schedule:SELECT_PAY_CODE')}
        required
      />
    </Flex>
  );
};
